module.exports = __webpack_public_path__ + "static/media/EnterpriseArchitectureConsulting.979c33b1.jpg";